import { DocumentDuplicateIcon } from "@heroicons/react/24/solid";

const ChangeOutlineButton = ({
  buttonText = "Save",
  type = "submit",
  className = "",
  disabled = false,
  onClick,
}) => {
  return (
    <button
      disabled={disabled}
      type={type}
      onClick={onClick}
      className={
        (disabled ? "cursor-not-allowed border  opacity-50 " : "opacity-100") +
        (buttonText === "Change PDF"
          ? `${className} flex items-center place-content-center hover:scale-90 transition duration-500 bg-transparent border-quinary shadow-md hover:bg-quinary text-quinary group relative py-1 px-3 gap-x-1 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quinary focus:ring-opacity-70`
          : `${className} flex items-center place-content-center hover:scale-90 transition duration-500 bg-transparent border-senary shadow-md hover:bg-senary text-senary group relative py-1 px-3 gap-x-1 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70`)
      }
    >
      <DocumentDuplicateIcon className="h-4 w-4" />

      <div className="-mt-auto">{buttonText}</div>
    </button>
  );
};
export default ChangeOutlineButton;
